import { render, staticRenderFns } from "./ImageFullModal.vue?vue&type=template&id=1112f8ff&scoped=true&"
import script from "./ImageFullModal.vue?vue&type=script&lang=js&"
export * from "./ImageFullModal.vue?vue&type=script&lang=js&"
import style0 from "./ImageFullModal.vue?vue&type=style&index=0&id=1112f8ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1112f8ff",
  null
  
)

export default component.exports